import GeoheatMapItem from './geoheatmap-map-item';

export default GeoheatMapItem;
export { GeoheatMapItem };
